<template>
  <div
    class="border rounded p-5"
    :class="{ 'bg-red-50 ': item.cancel_flag === 'c' }"
    v-for="(item, index) in items"
    :key="item.of_item_id"
  >
    <div class="flex flex-row justify-between">
      <div class="font-bold text-xl mb-4">ลำดับที่ {{ index + 1 }}.</div>
      <div class="flex flex-row">
        <div>
          <a
            href="javascript:;"
            class="btn btn-warning mt-2 mr-2"
            data-toggle="modal"
            data-target="#modal-ledget"
            @click="setUpdateOFItem(item.of_item_id)"
            v-if="item.is_edit_budget == 1 && page == 'detail'"
            :disabled="btnSaveBudget"
          >
            <SearchIcon
              class="w-4 h-4 mr-2 hidden md:block"
              v-if="!btnSaveBudget"
            />
            <LoadingIcon
              icon="oval"
              color="white"
              v-else
              class="w-4 h-4 mr-2"
            />
            แก้ไขงบโครงการ
          </a>
          <a
            href="javascript:;"
            class="btn btn-secondary btn-text mt-2 mr-2"
            v-else
          >
            เลขที่ {{ item.rf_no ? item.rf_no_full : '-' }}
          </a>
          <a
            href="javascript:;"
            class="btn btn-danger mt-2 mr-2"
            data-toggle="modal"
            data-target="#cancel-of-item-modal-preview"
            @click="setCancelOFItem(item.of_item_id)"
            v-if="item.cancel_flag !== 'c' && page == 'detail'"
          >
            <XCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
            ยกเลิก
          </a>
        </div>
        <div>
          <a
            href="javascript:;"
            class="btn btn-warning mt-2"
            @click="updateByItem(index)"
            v-if="
              props.isApprove &&
                !props.isClaim &&
                (props.isPermissionVat || props.isUpdateMaterial)
            "
          >
            <FeatherIcon class="w-4 h-4 mr-2 hidden md:block" />
            อัพเดท
          </a>
        </div>
      </div>
    </div>
    <div
      class="grid grid-cols-1 lg:grid-cols-3 space-y-2 lg:space-y-0 lg:gap-4"
    >
      <!-- col-1 -->
      <div class="col-span-2">
        <div class="text-lg font-bold">รายละเอียดสินค้า</div>
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div>
            <div class="mb-2">
              <div
                v-if="
                  !(props.isUpdateMaterial && props.isApprove && !props.isClaim)
                "
                class="flex flex-row lg:flex-col justify-between"
              >
                <label class="form-label font-bold">รายการสินค้า:</label>
                <div>{{ item.item_name }}</div>
              </div>
              <div v-else>
                <label class="form-label font-bold">รายการสินค้า:</label>
                <div class="">
                  <div class="p-fluid p-grid">
                    <div class="p-field p-field-sm">
                      <input
                        type="text"
                        class="form-control"
                        v-model="newItems[index].item_name"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">หมวดหมู่สินค้า:</div>
              <div>{{ item.item_category }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">รหัสชนิดสินค้า:</div>
              <div>{{ item.item_code }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">จำนวนคงเหลือ:</div>
              <div>{{ item.item_stock_qty }}</div>
            </div>

            <div class="flex justify-between">
              <div class="font-bold">วันที่ต้องการใช้:</div>
              <div>{{ item.use_date }}</div>
            </div>
          </div>
          <!-- col-2 -->
          <div>
            <div
              v-if="
                !(props.isPermissionVat && props.isApprove && !props.isClaim)
              "
            >
              <div class="flex justify-between">
                <div class="font-bold">หน่วยนับ:</div>
                <div>{{ item.uom }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">ราคาต่อหน่วย:</div>
                <div>{{ numberFormat(item.unit_price) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">ค่าแปลงหน่วย จาก 1 {{ item.uom }}:</div>
                <div>
                  {{ numberFormat4(item.unit_conversion_pos) }}
                  {{ item.item_stock_unit_pos }}
                </div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">จำนวนหน่วย:</div>
                <div>{{ numberFormat(item.qty) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">ราคาก่อนภาษี:</div>
                <div>{{ numberFormat(item.amount) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">
                  ภาษีมูลค่าเพิ่ม {{ item.vat_rate }}%:
                </div>
                <div>{{ numberFormat(item.vat) }}</div>
              </div>
              <div class="flex justify-between lg:mt-4">
                <div class="font-bold">Actual Cost:</div>
                <div>{{ numberFormat(item.actual_cost) }}</div>
              </div>
            </div>
            <div v-else>
              <div class="grid grid-cols-2 gap-2">
                <div class="">
                  <label for="material-type" class="form-label font-bold"
                    >หน่วยนับ:</label
                  >
                  <select
                    id="material-type"
                    class="form-select form-control w-full"
                    v-model="newItems[index].uom_code"
                    @change="changeUom(index)"
                  >
                    <option :value="null" key="0">-- เลือกหน่วยนับ --</option>
                    <option
                      :value="uom.value.trim()"
                      v-for="uom in uomOptions"
                      :key="uom.value"
                      >{{ uom.label }}</option
                    >
                  </select>
                </div>
                <div class="">
                  <label for="" class="form-label font-bold"
                    >ราคาต่อหน่วย:</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    v-model.number="newItems[index].unit_price"
                    @keyup="summaryAmount(index)"
                    @change="summaryAmount(index)"
                  />
                </div>
              </div>
              <div class="grid grid-cols-2 gap-2">
                <div class="lg:mt-4">
                  <label for="" class="form-label font-bold">จำนวนหน่วย:</label>
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    v-model.number="newItems[index].qty"
                    @keyup="summaryAmount(index)"
                    @change="summaryAmount(index)"
                  />
                </div>
                <div class="lg:mt-4">
                  <label for="" class="form-label font-bold"
                    >ค่าแปลงหน่วย จาก 1 {{ newItems[index].uom }}:</label
                  >
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      v-model.number="newItems[index].unit_conversion_pos"
                    />
                    <div class="input-group-text">
                      {{ newItems[index].item_stock_unit_pos ?? '-' }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="lg:mt-4">
                <label for="" class="form-label font-bold">ราคาก่อนภาษี:</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  v-model.number="newItems[index].amount"
                  @keyup="calVatRate(index)"
                  @change="calVatRate(index)"
                />
              </div>
              <div class="lg:mt-4">
                <label for="" class="form-label font-bold"
                  >ภาษีมูลค่าเพิ่ม:</label
                >
                <div class="grid grid-cols-3 gap-4">
                  <div class="col-span-2">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model.number="newItems[index].vat"
                      @keyup="calVat(index)"
                      @change="calVat(index)"
                    />
                  </div>
                  <div>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      class="form-control"
                      v-model.number="newItems[index].vat_rate"
                      @keyup="calVatRate(index)"
                      @change="calVatRate(index)"
                    />
                  </div>
                </div>
              </div>
              <div class="flex justify-between lg:mt-4">
                <div class="font-bold">Actual Cost:</div>
                <div>{{ numberFormat(newItems[index].actual_cost) }}</div>
              </div>
            </div>
            <!-- <div
              class="mt-4"
              v-if="props.isPermissionVat && props.isApprove && !props.isClaim"
            >
              <button class="btn btn-warning" @click="updateExpense(index)">
                อัพเดท
              </button>
            </div> -->
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div>
            <div class="mt-4 text-lg font-bold">ส่งสินค้า:</div>
            <div class="flex justify-between">
              <div class="font-bold">เงื่อนไขการชำระเงิน:</div>
              <div>{{ item.payment_term_name }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">เงื่อนไขการส่งสินค้า:</div>
              <div>{{ item.shipping_condition_send }}</div>
            </div>
            <div class="">
              <div class="font-bold">สถานที่รับสินค้า:</div>
              <div>{{ item.pickup_loc }}</div>
            </div>
            <div class="mt-4">
              <div class="text-lg font-bold">ข้อมูลผู้ค้า:</div>
              <div
                v-if="
                  props.isUpdateMaterial && props.isApprove && !props.isClaim
                "
              >
                <div class="">
                  <label for="" class="form-label ">ชื่อผู้ค้า </label>
                  <div class="preview w-full">
                    <WfSelectSingleVendor
                      key="wfselect-item-vendor"
                      v-model="newItems[index].vendor_code"
                      :options="{
                        ajaxLimit: 50,
                        searchMinLength: 3
                      }"
                    ></WfSelectSingleVendor>
                    <!-- <span
                      class="text-theme-6"
                      v-if="validateItem.vendorSelected.$error"
                      >{{
                        validateItem.vendorSelected.required.$message
                      }}</span
                    > -->
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="">
                  <div class="font-bold">ชื่อผู้ค้า:</div>
                  <div>
                    {{
                      typeof item.vendor_code == 'object'
                        ? item.vendor_code.vendor_code
                        : item.vendor_code
                    }}
                    - {{ item.vendor_name }}
                  </div>
                </div>
                <div class="">
                  <div class="font-bold">ที่อยู่:</div>
                  <div>{{ item.vendor_address }}</div>
                </div>
                <div class="flex justify-between">
                  <div class="font-bold">อีเมล:</div>
                  <div>{{ item.vendor_email }}</div>
                </div>
                <div class="flex justify-between">
                  <div class="font-bold">โทร:</div>
                  <div>{{ item.vendor_tel }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- col-3 -->
      <div>
        <div class="text-lg font-bold">รายละเอียดงบประมาณ</div>
        <!-- ปีงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ปีงบประมาณ:
          </div>
          <div>{{ item.budget_year }}</div>
        </div>
        <!-- ชนิดงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ชนิดงบประมาณ:
          </div>
          <div>
            {{ item.budget_subledger ? 'งบประมาณโครงการ' : 'งบประมาณหน่วยงาน' }}
          </div>
        </div>
        <!-- ใช้งบประมาณของหน่วยงาน -->
        <div class="">
          <div class="font-bold">
            ใช้งบประมาณของหน่วยงาน:
          </div>
          <div>
            {{ item.budget_bu_name }}
          </div>
        </div>
        <!-- รหัส BU -->
        <div class="flex justify-between">
          <div class="font-bold">
            รหัส BU:
          </div>
          <div>
            {{ item.budget_bu_code }}
          </div>
        </div>
        <!-- account code -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Code:
          </div>
          <div>
            {{ item.budget_code }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subsidiary:
          </div>
          <div>
            {{ item.budget_subsidiary }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Name:
          </div>
          <div>
            {{ item.budget_name }}
          </div>
        </div>
        <!-- Subledger -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger:
          </div>
          <div>
            {{ item.budget_subledger }}
          </div>
        </div>
        <!-- Subledger Name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger Name:
          </div>
          <div>
            {{ item.budget_subledger_name }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="item.cancel_flag === 'c'">
      <div class="text-theme-6">
        <b>เหตุผลการยกเลิก</b> : {{ item.history }}
      </div>
    </div>
  </div>
  <!-- BEGIN: Modal Content -->
  <div
    id="cancel-of-item-modal-preview"
    class="modal"
    tabindex="-1"
    data-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5">คุณแน่ใจ</div>
            <div class="text-gray-600 mt-2">
              ต้องการลบรายการนี้ ใช่ หรือ ไม่?
            </div>
            <div class="mt-4 text-left">
              <label for="" class="form-label text-lg"
                >เหตุผลในการยกเลิก:</label
              >
              <textarea
                name=""
                class="form-control"
                rows="5"
                v-model="currentReason"
                placeholder="เพิ่มเติม..."
              ></textarea>
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
              @click="cancelOFItem()"
            >
              ไม่
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-danger w-24"
              @click="confirmCancelOFItem()"
            >
              ใช่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for budget subledger -->
  <div id="modal-ledget" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body p-10 text-center">
          <TableBudget
            v-model="budgetSubledgerSelected"
            @setBudget="setBudget"
            :company="props.compCode"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, reactive, onMounted, watch } from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import helpers from '@/helpers'
import alert from '@/helpers/alert'
import { api } from '@/utils/api'
import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'
import TableBudget from '@/components/table-budget/Main.vue'
// import MaterialVendorUpdate from '@/components/MaterialVendorUpdate.vue'

export default defineComponent({
  name: 'table-item-of',
  components: {
    // MaterialVendorUpdate
    TableBudget,
    WfSelectSingleVendor
  },
  props: {
    items: Array,
    isPermissionVat: {
      type: Boolean,
      default: () => false
    },
    isApprove: {
      type: Boolean,
      default: () => false
    },
    isClaim: {
      type: Boolean,
      default: () => false
    },
    isUpdateMaterial: {
      type: Boolean,
      default: () => false
    },
    page: {
      type: String,
      default: () => 'detail'
    },
    compCode: {
      type: String,
      default: () => null
    }
  },
  emits: ['updateCancel', 'updateBudget'],
  setup(props, context) {
    const store = useStore()
    const route = useRoute()
    const taxRateRequired = reactive({
      index: null,
      required: false
    })

    const uomOptions = computed(() => store.getters['global/getUOMOptions'])
    const newItems = ref([...props.items])
    const uomCurrent = reactive({ label: null, value: null })
    // const newItems = ref([])

    const budgetSubledgerSelected = ref(null)
    watch(
      () => props.items,
      newVal => {
        newItems.value = [...newVal]
      }
    )

    const changeUom = index => {
      const uom = uomOptions.value.find(
        v => v.value == props.items[index].uom_code
      )
      if (uom) {
        newItems.value[index].uom = uom.label
      }
    }

    const btnSaveBudget = ref(false)
    const budgetInfo = ref({
      budget_year: null,
      budget_bu_req_code: null,
      budget_bu_req_name: null,
      budget_bu_code: null,
      budget_bu_name: null,
      budget_type: null,
      budget_code: null,
      budget_name: null,
      budget_subsidiary: null,
      budget_subledger: null,
      budget_subledger_name: null,
      budget_group_code: null,
      budget_group_name: null
    })

    const setBudget = async val => {
      budgetInfo.value.budget_year = val.year
      budgetInfo.value.budget_type = val.subledger ? null : 'bu'
      budgetInfo.value.budget_bu_code = val.bu_code
      budgetInfo.value.budget_bu_name = val.bu_name
      budgetInfo.value.budget_bu_req_code = val.bu_code
      budgetInfo.value.budget_bu_req_name = val.bu_name
      budgetInfo.value.budget_code = val.account_code
      budgetInfo.value.budget_name = val.account_name
      budgetInfo.value.budget_subsidiary = val.subsidiary
      budgetInfo.value.budget_subledger = val.subledger
      budgetInfo.value.budget_subledger_name = val.subledger_name

      btnSaveBudget.value = true

      await api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/of/updateBudgetItem/${currentItemId.value}`,
          budgetInfo.value
        )
        .then(res => {
          if (res.code == 200) {
            alert.success('บันทึกข้อมูลสำเร็จ')

            context.emit('updateBudget', {
              itemId: currentItemId.value,
              budgetInfo: budgetInfo.value
            })
          } else {
            alert.error('ไม่สามารถบันทึกข้อมูลได้')
          }
        })
        .catch(e => {
          alert.error(e.message)
          btnSaveBudget.value = false
          budgetSubledgerSelected.value = null
        })
        .finally(() => {
          budgetSubledgerSelected.value = null
          btnSaveBudget.value = false
        })
    }

    const updateExpense = async i => {
      const uom = store.getters['global/getUOMbyOne'](
        newItems.value[i].uom_code
      )
      const data = {
        uom: uom.uom_name,
        uom_code: uom.uom_code,
        unit_price: newItems.value[i].unit_price,
        qty: newItems.value[i].qty,
        unit_conversion_pos: newItems.value[i].unit_conversion_pos,
        amount: newItems.value[i].amount,
        vat: newItems.value[i].vat,
        vat_rate: newItems.value[i].vat_rate,
        actual_cost: newItems.value[i].actual_cost,
        approve_token: route.query.token
      }
      return await api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/of/updateItemExpenses/${props.items[i].of_item_id}`,
          data
        )
        .then(res => {
          return res.code == 200
        })
        .catch(e => {
          alert.error(e.message)
          return false
        })
    }

    const updateByItem = async i => {
      let flagUpdate = false
      if (props.isPermissionVat && props.isApprove && !props.isClaim) {
        flagUpdate = await updateExpense(i)
      }
      if (props.isUpdateMaterial && props.isApprove && !props.isClaim) {
        await api
          .post(`${process.env.VUE_APP_API_URL}/preorder/materialVendor/save`, {
            vendor_code:
              typeof newItems.value[i].vendor_code == 'object'
                ? newItems.value[i].vendor_code.vendor_code
                : newItems.value[i].vendor_code,
            material_code: newItems.value[i].item_code,
            description: newItems.value[i].item_name
          })
          .then(res => {
            flagUpdate = res.code == 200
          })
          .catch(e => {
            alert.error(e.message)
          })

        if (typeof newItems.value[i].vendor_code == 'object') {
          await api
            .put(
              `${process.env.VUE_APP_API_URL}/preorder/of/updateItemByPurchase/${props.items[i].of_item_id}`,
              {
                vendor_code: newItems.value[i].vendor_code.vendor_code, // 11VEN-00037 , 11Tast-1
                vendor_name: newItems.value[i].vendor_code.vendor_name,
                vendor_address: newItems.value[i].vendor_code.vendor_address,
                vendor_telephone: newItems.value[i].vendor_code.vendor_telephone
              }
            )
            .then(res => {
              flagUpdate = res.code == 200
            })
            .catch(e => {
              alert.error(e.message)
            })
        }
        // update of item
        await api
          .put(`/preorder/of/updateItemName/${props.items[i].of_item_id}`, {
            item_name: newItems.value[i].item_name
          })
          .then(res => {
            flagUpdate = res.code == 200
          })
      }
      if (flagUpdate) {
        await alert.success()
      } else {
        await alert.error()
      }
    }

    const { numberFormat, numberFormat2, numberFormat4 } = helpers

    const calVat = i => {
      newItems.value[i].actual_cost =
        newItems.value[i].amount + newItems.value[i].vat
    }

    const calVatRate = i => {
      newItems.value[i].vat =
        (newItems.value[i].amount * newItems.value[i].vat_rate) / 100
      calVat(i)
    }

    const currentItemId = ref(null)
    const currentReason = ref(null)
    const setCancelOFItem = id => {
      currentItemId.value = id
      currentReason.value = null
    }

    const setUpdateOFItem = id => {
      currentItemId.value = id
    }

    const cancelOFItem = () => {
      currentItemId.value = null
      currentReason.value = null
    }

    const confirmCancelOFItem = () => {
      context.emit('updateCancel', {
        itemId: currentItemId.value,
        reason: currentReason.value
      })
      currentItemId.value = null
      currentReason.value = null
      // alert.success()
    }

    // console.log('itmes:', props.items)

    const summaryAmount = i => {
      newItems.value[i].amount = parseFloat(
        numberFormat2(newItems.value[i].unit_price * newItems.value[i].qty)
      )
      calVatRate(i)
    }

    onMounted(async () => {
      store.dispatch('global/loadUOM')
    })
    return {
      props,
      numberFormat,
      numberFormat4,
      calVat,
      calVatRate,
      newItems,
      // updateExpense,
      taxRateRequired,
      setCancelOFItem,
      setUpdateOFItem,
      cancelOFItem,
      confirmCancelOFItem,
      currentReason,
      uomOptions,
      summaryAmount,
      updateByItem,
      uomCurrent,
      changeUom,
      setBudget,
      budgetSubledgerSelected
    }
  }
})
</script>

<style scoped></style>
